import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/go";
import { DSService } from "../../services";
import { formatErrors } from "../../helpers/ErrorFormater";
import { MessageTypes } from "../../helpers/Messages";
import i18next from "i18next";

function* getData({ value }) {
  try {
    const { data } = yield call(() => DSService.getData('go', value));
    if (data) {
      yield put({
        type: types.GO_DATA_SUCCESS,
        value: { [`${value.module}-${value.view}`]: data },
      });
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.GO_DATA_FAILED,
      value: formattedErrors,
    });
  }
}

function* submit({ value, callback }) {
  const { module, view, ...forms } = value || {};
  try {
    const {
      data,
    } = yield call(() => DSService.submit('go', { ...forms, module, view }));
    if (data) {
      yield put({
        type: types.GO_SUBMIT_SUCCESS,
        value: { ...data, module, view }
      });

      callback(
        MessageTypes.SUCCESS,
        i18next.t('Information submitted successfully')
      );
    } else {
      callback(
        MessageTypes.WARNING,
        i18next.t('errors::Something wrong happend during saving data')
      );
    }
  } catch (e) {
    console.log(e);
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.GO_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(
        MessageTypes.WARNING,
        i18next.t('errors::Please fill all required fields')
      );
    } else {
      callback(
        MessageTypes.WARNING,
        i18next.t('errors::Something wrong happend during saving data')
      );
    }
  }
}

export default function* init() {
  yield takeEvery(
    types.GO_DATA,
    getData,
  );
  yield takeEvery(
    types.GO_SUBMIT,
    submit,
  );
}
